import { apiInstance } from "api/config/axios";
import { getApiResponseData } from "./api-service";
import { IApiResponse } from "api/models/IApiResponse";
import { IWorkspacePlanModel } from "api/models/response/workspacePlan/IWorkspacePlanModel";
import { ISaveWorkspacePlanRequest } from "api/models/request/workspacePlan/ISaveWorkspacePlanRequest";
import { IWorkspaceStorageUsageModel } from "@api/models/response/workspacePlan/IWorkspaceStorageUsageModel";

const workspacePlanApiBaseUrl = '/workspace-plans';

export const getWorkspaceStorageUsage = (
  workspaceId: string,
): Promise<IApiResponse<IWorkspaceStorageUsageModel>> => {
  return apiInstance
    .get(`${workspacePlanApiBaseUrl}/workspaces/${workspaceId}/storage-usage`)
    .then(getApiResponseData);
};

export const getWorkspacePlans = (): Promise<IApiResponse<IWorkspacePlanModel[]>> => {
    return apiInstance.get(workspacePlanApiBaseUrl).then((response) => {
        return getApiResponseData(response);
    });
};

export const createWorkspacePlan = (request: ISaveWorkspacePlanRequest): Promise<IApiResponse<IWorkspacePlanModel>> => {
    return apiInstance.post(workspacePlanApiBaseUrl, request).then((response) => {
        return getApiResponseData(response);
    });
};

export const updateWorkspacePlan = (
    request: { workspaceId: string; planId: string } & ISaveWorkspacePlanRequest
): Promise<IApiResponse<IWorkspacePlanModel>> => {
    const { workspaceId, planId, ...body } = request;
    return apiInstance.put(`${workspacePlanApiBaseUrl}/workspace/${workspaceId}/plan/${planId}`, body).then((response) => {
        return getApiResponseData(response);
    });
};

export const deleteWorkspacePlan = (request: { workspaceId: string; planId: string }): Promise<void> => {
    return apiInstance.delete(`${workspacePlanApiBaseUrl}/workspace/${request.workspaceId}/plan/${request.planId}`).then(() => undefined);
};
